import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BuildingService } from 'src/app/app/building/building.service';
import { CompanyService } from 'src/app/app/company/company.service';
import { Animations } from 'src/app/_helpers/animations';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { GuestReportService } from '../guest-report.service';
import { GuestReportViewComponent } from '../guest-report-view/guest-report-view.component';
import { GuestReport, GuestReportType } from '../guest-report.model';

@Component({
  selector: 'app-guest-report-modal-filter',
  templateUrl: './guest-report-modal-filter.component.html',
  styleUrls: ['./guest-report-modal-filter.component.scss'],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class GuestReportModalFilterComponent implements OnInit {

  showBuildings: boolean = false;
  showCompanies: boolean = false;
  showDates: boolean = false;
  showLoader: boolean = true;

  guestReportsFilter: GuestReport[];
  rowsLoader: RowsLoaderService;
  componentRef: any = GuestReportViewComponent;

  constructor(
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public p: ThisPlatform,
    public guestReportServ: GuestReportService,
    public buildingServ: BuildingService,
    public companyServ: CompanyService,
  ) { }

  ngOnInit() {
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.guestReportServ.getDataForChart(this.guestReportsFilter)
      this.guestReportsFilter = this.guestReportServ.guestReports.filter((s) => {
        return (
          (
            s.buildingName +
            " " +
            s.companyName +
            " " +
            s.date +
            " " +
            s.entry +
            " " +
            s.leave

          )
        );
      });
    }
    this.rowsLoader.init(this.guestReportsFilter);
  }

  rowsLoaderRefresh() {
    this.rowsLoader.init(this.guestReportsFilter);
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  getFilterGuestReports() {
    this.guestReportServ.request = {
      type: GuestReportType.Guest.toString(),
      dateFrom: this.guestReportServ.requestParameters.dateFrom ? this.guestReportServ.requestParameters.dateFrom : null,
      dateTo: this.guestReportServ.requestParameters.dateTo ? this.guestReportServ.requestParameters.dateTo : null,
      idBuilding: this.guestReportServ.requestParameters.building ? this.guestReportServ.requestParameters.building.id : null,
      idCompany: this.guestReportServ.requestParameters.company ? this.guestReportServ.requestParameters.company.id : null ,
    }

    this.guestReportServ.getGuestReports(this.guestReportServ.request).subscribe((res) => {
      this.guestReportServ.guestReports = this.guestReportsFilter = res;
      this.showLoader = false;
      this.guestReportServ.refreshChart(this.guestReportsFilter);
      this.onRefreshChart()
      this.guestReportServ.reloadFilter();
    });
  }

  onFilterBuilding(building) {
    this.guestReportServ.requestParameters.building = building
    this.getFilterGuestReports();
  }

  onFilterCompany(company) {
    this.guestReportServ.requestParameters.company = company  
    this.getFilterGuestReports();
  }

  onFilterDate(date, whichDate: string = "start" || "end") {
    if (whichDate == "start") {
      this.guestReportServ.requestParameters.dateFrom = date;
    } else if (whichDate == "end") {
      this.guestReportServ.requestParameters.dateTo = date;
    }

    this.getFilterGuestReports();
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }

  onClearFilters() {
    this.guestReportServ.requestParameters = {
      building: null,
      company: null,
      dateFrom: new Date(new Date().getDate()).toDateString(),
      dateTo: new Date(Date.now()).toDateString(),
    };

    this.getFilterGuestReports();
  }

  onRefreshChart(){
    this.guestReportServ.loadChart(
      this.guestReportServ.enter,
      this.guestReportServ.leave,
      this.guestReportServ.date,
    );
  }

}
